import { FaPen ,FaTrashAlt } from 'react-icons/fa';

export const processColumns = (openModal, clickDelete) => [
  { header: '개발일', accessor: 'devDt' },
  { header: '담당자', accessor: 'userName' },
  { header: '공정명', accessor: 'processName' },
  { header: '공정코드', accessor: 'processCode' },
  // { header: '사용 기계', accessor: 'machineName' },
  { header: '공임비', accessor: 'processFee', render: (row) => `${(row.processFee ?? 0).toLocaleString()} 원` },
  // { header: '단위', accessor: 'stockUnitCode' },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); openModal(2, 1, row); }} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(1, row); }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const processFormFields = [
  { key: "processSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "devDt", label: "개발일", type: "date", size: 6, visible: true, required: false },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true, required: true },
  // { key: "machineSeq", label: "사용 기계", type: "apiSelect", apiKey: 'machine',  labelKey: "machineName", valueKey: "machineSeq", size: 6, visible: true, required: false },
  { key: "processName", label: "공정명", type: "text", size: 6, visible: true, required: true },
  { key: "processCode", label: "공정 코드", type: "text", size: 6, visible: true, required: true },
  { key: "processFee", label: "공임비", type: "number", size: 6, visible: true, required: true },
  // { key: "stockUnitCode", label: "단위", type: "text", size: 6, visible: true, required: true },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false },
];

export const processSearchFormFields = [
  { key: "processName", label: "공정명", type: "text", size: 6, visible: true },
  { key: "processCode", label: "공정 코드", type: "text", size: 6, visible: true },
  { key: "processFee", label: "공임비", type: "number", size: 6, visible: true },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true },
  { key: "devDt", label: "개발일", type: "date", size: 6, visible: true },
];

export const processBOMColumns = (openModal, clickDelete) => [
  { header: '자재명', accessor: 'materialName' },
  { header: '규격', accessor: 'materialSpec' },
  { header: '자재코드', accessor: 'materialCode' },
  { header: '소요량', accessor: 'consume' },
  { header: '단위', accessor: 'stockUnitCode' },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); openModal(2, 2, row); }} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(2, row) }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const processBOMFormFields = [
  { key: "processBOMSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "processSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "materialSeq", label: "자재", type: "apiSelect", apiKey: "material", labelKey: "materialName", valueKey: "materialSeq", visible: true, required: true },
  { key: "consume", label: "소모량", type: "number", size: 6, visible: true, required: true },
  { key: "sort", label: "정렬", type: "number", size: 6, visible: false, required: false, default: 1 },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false, default: '' },
];